import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function useOrgLists() {
  const [lists, setLists] = useState({ divisions: [], positions: [], groups: [], loaded: false });
  useEffect(() => {
    Promise.all([api.get("/r/divisions"), api.get("/r/positions"), api.get("/r/staff_groups")])
      .then(([d, p, g]) => setLists({
        divisions: d.data.map((x) => x.name).sort(),
        positions: p.data.map((x) => x.name).sort((a, b) => a.localeCompare(b)),
        groups: g.data.map((x) => ({ value: x.id, label: x.name })).sort((a, b) => a.label.localeCompare(b.label)),
        loaded: true,
      }))
      .catch(() => setLists((l) => ({ ...l, loaded: true })));
  }, []);
  return lists;
}

export function orgField(key, label, options, extra = {}) {
  return options.length ? { key, label, type: "select", options, ...extra } : { key, label, ...extra };
}
